(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["btown-lp-add-button"] && !Shopify.designMode) return;
  try {
    
var pagetop = $('.scroll_up');
$(window).scroll(function () {
  if ($(this).scrollTop() > 700) {
    pagetop.fadeIn();
  } else {
    pagetop.fadeOut();
  }
});
  
var pagetop_sp = $('.scroll_up_sp');
$(window).scroll(function () {
     if ($(this).scrollTop() > 500) {
          pagetop_sp.fadeIn();
     } else {
          pagetop_sp.fadeOut();
     }
  });
  

  } catch(e) { console.error(e); }
})();
})();
